"use strict";

/**
* Кнопка панели инструментов.
* 
* @class WebAccess.components.wrappers.toolBar.ToolBarButton
* @extends WebAccess.components.wrappers.BasePageElement
* @property {string} name Имя кнопки
* @property {group} groupName Группа, в которую вложена кнопка
* @property {string} selector Путь в DOM-иерархии к объекту кнопки, например div.content#container   
* @property {boolean} isSynthetic Признак, указывающий на то, что закладка была создана средствами API
* @param {string} itemSelector Существующий элемент страницы
*/

(function (global) {

  var buttonSelector = "div.toolbar_button";
  var groupSelector = "div.toolbar_group";

  // Признак доступности действия, если в области вложений выделен хотя бы один элемент.
  var isEnabledOnAttachmentSelected = 1 << 0;

  // Признак доступности действия, если ЗЗУ прекращено.
  var isEnabledOnAborted = 1 << 1;

  // Признак доступности действия, если ЗЗУ выполнено.
  var isEnabledOnDone = 1 << 2;

  // Признак доступности действия, если ЗЗУ в работе.
  var isEnabledOnRunning = 1 << 3;

  var ToolBarButton = global.components.wrappers.BasePageElement.extend({
    init: function (itemSelector) {
      this._super(itemSelector);
      this.selector = format(this._byNameSelectorTemplate, buttonSelector, this.name);
      this.groupName = this._jObject.parents(groupSelector).attr("name");
      this._jGroup = this._jObject.parents(groupSelector);

      // Если мы создаем кнопку динамически, и говорим что она 
      // должна быть маленькой, но при этом указываем большую иконку,
      // то приходится конверитровать её здесь
      if (!this._jObject.data("icon")) {
        this._jObject.data("icon", this._jObject.find('p').attr('class'));
      };
      if (this.isSmall()) {
        this._setupSmallIcon();
      };

      // Установка свойства связанного прикладного действия
      this._linkedAction = this._jObject.data('linkedaction');
      this._enabledMode = this._jObject.data('enabledmode');
      var enabledWhen = this._jObject.data('enabledwhen');
      if (enabledWhen) {
        this._enabledWhen = enabledWhen;
      }

      // Получить тексты всплывающих подсказок
      this._disabledHint = this._jObject.data('disabledhint');
      this._hint = this._jObject.data('hint');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: "ToolBarButton",
    groupName: "",
    isSynthetic: false,
    _jGroup: null,
    _inlineEvent: "",
    _isConverted: false,
    _linkedAction: null,
    _enabledMode: null,
    _disabledHint: "",
    _hint: "",
    _enabledWhen: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @private
    */
    _setupIcon: function (firstIcon, secondIcon, from, to) {
      if (!!firstIcon) {
        this._jObject.find('p').removeClass().addClass(firstIcon);
      } else {
        if (!!secondIcon) {
          var picName = secondIcon.split(".")[0];
          if (picName.indexOf("_" + from) !== -1) {
            picName = picName.replace("_" + from, "_" + to);
            picName += ".png";
          } else {
            picName += "_" + to + ".png";
          };
          this._jObject.find('p').removeClass().addClass(picName);
        };
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Пробуем получить маленькую иконку.
    * @private
    */
    _setupSmallIcon: function () {
      var storedSmallIcon = this._jObject.data("smallicon");
      var storedLargeIcon = this._jObject.data("icon");
      this._setupIcon(storedSmallIcon, storedLargeIcon, "32", "16");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Пробуем получить большую иконку.
    * @private
    */
    _setupLargeIcon: function () {
      var storedSmallIcon = this._jObject.data("smallicon");
      var storedLargeIcon = this._jObject.data("icon");
      this._setupIcon(storedLargeIcon, storedSmallIcon, "16", "32");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменение размера и перемещение большой кнопки в колонку.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#_putInColumn
    * @private
    */
    _putInColumn: function (jColumn) {
      var me = this;
      me._jObject.removeClass('toolbar_item').addClass('small_toolbar_item');
      me._setupSmallIcon();
      $(me._jObject).prependTo(jColumn);
      me._isConverted = true; //Чтобы сохранить следы для обратного восстановления
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменение размера и перемещение маленькой кнопки из колонки в большую.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#_putInColumn
    * @private
    */
    _takeFromColumn: function (jColumn) {
      var me = this;
      me._jObject.removeClass('small_toolbar_item').addClass('toolbar_item');
      me._setupLargeIcon();
      $(me._jObject).insertBefore(jColumn);
      me._isConverted = true; //Чтобы сохранить следы для обратного восстановления
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Логика конвертирования из большой кнопки в маленькую.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#_convertToSmall
    * @private
    */
    _convertToSmall: function () {
      var me = this;
      var largeButtonsCount = me._jGroup.find(".toolbar_item").length;
      var firstColumnSelector = ".toolbar_column:first";
      var jFirstColumn = me._jObject.nextAll(firstColumnSelector);
      if (!me.isSmall() && (largeButtonsCount > 1 || jFirstColumn.length > 0)) {
        if (me._jGroup.find(".toolbar_column").length > 0 && jFirstColumn.length > 0) {
          if (jFirstColumn.find(".small_toolbar_item").length < 3) {
            //Ковертируем в маленькую и переводим в колонку            
            me._putInColumn(jFirstColumn);
          } else {
            if (largeButtonsCount > 1 && me._jObject.prev().is(".toolbar_item")) {
              //Создаем колонку, вставляем перед всеми колонками
              //Ковертируем в маленькую и переводим в колонку
              var jColumn = $('<div class="toolbar_column"></div>');
              jColumn.insertBefore(jFirstColumn);
              me._putInColumn(jColumn);
            }
          }
        } else {
          //Создаем колонку, вставляем в конце
          //Ковертируем в маленькую и переводим в колонку
          var jColumn = $('<div class="toolbar_column"></div>');
          me._jGroup.append(jColumn);
          me._putInColumn(jColumn);
        }
        fixSvg(me._jGroup[0]);
      };
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Конвертация мальенькой кнопки в большую
    * @private
    */
    _convertToLarge: function () {
      var me = this;
      if (me.isSmall()) {
        me._jColumn = me._jObject.parent('.toolbar_column');
        me._takeFromColumn(me._jColumn);
        if (me._jColumn.find(".toolbar_button").length == 0) me._jColumn.remove();
        fixSvg(me._jGroup[0]);
      };
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменить регистр букв.
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#convertTo
    * @param {BUTTON} buttonType Тип кнопки  
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    * @since 5.0.0.4104
    */
    convertTo: function (buttonType) {
      switch (buttonType) {
        case BUTTON.SMALL:
          return this._convertToSmall();
        case BUTTON.LARGE:
          return this._convertToLarge();
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить наименование прикладного действия, связанного с кнопкной на ленте.
    * @function WebAccess.components.wrappers.toolBar.ToolBarButton#getLinkedAction
    * @return {string} Наименование связанного с кнопкой прикладного действия. Если действие не указано - undefined.
    */
    getLinkedAction: function () {
      return this._linkedAction;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить режим доступности действия.
    * @function WebAccess.components.wrappers.toolBar.ToolBarButton#getEnabledMode
    * @return {ACTION_ENABLED_MODE} Режим доступности кнопки.
    */
    getEnabledMode: function () {
      return this._enabledMode;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить режим доступности действия для состояния "Прекращено".
    * @function WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnAborted
    * @return {boolean} True - если кнопка доступна, иначе False.
    */
    getIsEnabledOnAttachnentSelected: function () {
      var me = this;
      if (me._enabledWhen) {
        return Boolean(me._enabledWhen & isEnabledOnAttachmentSelected);
      }
      return false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить режим доступности действия для состояния "Прекращено".
    * @function WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnAborted
    * @return {boolean} True - если кнопка доступна, иначе False.
    */
    getIsEnabledOnAborted: function () {
      var me = this;
      if (me._enabledWhen) {
        return Boolean(me._enabledWhen & isEnabledOnAborted);
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить режим доступности действия для состояния "Выполнено".
    * @function WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnDone
    * @return {boolean} True - если кнопка доступна, иначе False.
    */
    getIsEnabledOnDone: function () {
      var me = this;
      if (me._enabledWhen) {
        return Boolean(me._enabledWhen & isEnabledOnDone);
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить режим доступности действия для состояния "В работе".
    * @function WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnRunning
    * @return {boolean} True - если кнопка доступна, иначе False.
    */
    getIsEnabledOnRunning: function () {
      var me = this;
      if (me._enabledWhen) {
        return Boolean(me._enabledWhen & isEnabledOnRunning);
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
    * Устанавливает для кнопки состояние "Нажата"
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#select
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    * @since 5.2.0.1100
    */
    select: function () {
      this._jObject.addClass("selected");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Устанавливает для кнопки состояние "Не нажата"
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#unSelect
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    * @since 5.2.0.1100
    */
    unSelect: function () {
      this._jObject.removeClass("selected");
      return this
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить значение состояния кнопки.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#isSelect
    * @return {boolean} True, если кнопка нажата, иначе False.
    * @since 5.3.0.1104
    */
    isSelected: function () {
      return this._jObject.hasClass("selected");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак кнопки маленького размера.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#isSmall
    * @return {boolean} True, если кнопка маленького размера, иначе False.
    * @since 5.0.0.4104
    */
    isSmall: function () {
      return this._jObject.hasClass("small_toolbar_item");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить родительскую группу кнопок.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#group
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarGroup.
    */
    group: function () {
      this.groupName = this._jObject.parents(groupSelector).attr("name");
      return global.current.toolBar.groups[this.groupName];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    click: function (opt_callback) {
      if ($.isFunction(opt_callback)) {
        this.unbind("click");
      };
      this._super(opt_callback);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    bind: function (event, callback) {
      this._super(event, callback);
      if (this.isSynthetic && event == "click") { //Убираем алерт с подсказкой
        this._jObject.removeAttr("onclick"); // Здесь именно так 
        this._jObject.prop("onclick", null); // именно две строки
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрытие кнопки.
    * 
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#hide
    * @comment Keit_B: Новый. Пока не трогаю, ранее наследовался от BasePageElement.
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} 
    */
    hide: function () {
      var me = this;
      me._super();
      if (me._jGroup.find('.toolbar_button:visible').length === 0) {
        me.group().hideNextSeparator();
      };
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Показ скрытой кнопки.
     * 
     * @comment Keit_B: Новый. Пока не трогаю, ранее наследовался от BasePageElement.
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#show
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton}
    */
    show: function () {
      var me = this;
      me._super();
      if (me._jGroup.find('.toolbar_button:visible').length > 0) {
        me.group().showNextSeparator();
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Заблокировать кнопку.
     * 
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#disable
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton}
    */
    disable: function () {
      var me = this;
      me._super();
      me._setActualHint();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Разблокировать кнопку.
     * 
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#enable
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton}
    */
    enable: function () {
      var me = this;
      me._super();
      me._setActualHint();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установить тексты всплывающих подсказок.
     * 
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#setHints
     * @param {string} hint Текст всплывающей подсказки.
     * @param {string} disabledHint Текст всплывающей подсказки при заблокированной кнопке.
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton}
    */
    setHints: function (hint, disabledHint) {
      var me = this;
      me._hint = hint;
      me._disabledHint = disabledHint;
      me._setActualHint();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установить подсказку на основе состояния действия и значений свойств.
     *
     * @private
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#_setActualHint
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton}
    */
    _setActualHint: function() {
      var me = this;
      if (!me.isEnabled() && me._disabledHint) {
        me.setTooltip(me._disabledHint);
      } else {
        if (me._hint) {
          me.setTooltip(me._hint);
        } else {
          me.setTooltip(me.getLabel());
        }
      }
    }
  });

  global.components.wrappers.toolBar.ToolBarButton = ToolBarButton;
})(window.WebAccess);